import { httpClient } from '@/services/http/httpClient'

export async function syncMicrosoftUsers(): Promise<void> {
  await httpClient.post('/users/sync/microsoft')
}
